import { useQuery } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import { urls } from '../../config/urls';

export const useLanguages = () => {
  return useQuery('languages', () =>
    axiosInstance.get(urls.languages.all).then((res) => res.data)
  );
};
